<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>تحويل بضاعة بين مخازن الفرع</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع تحويلات البضاعة بين مخازن الفرع
                                <div v-show="$per.value.saveStoreMovment" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                                <ul v-if='mainValidationErrors'>
                                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-12' style="margin:10px;padding:0px">
                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                      <label>الفرع</label>
                                      <select class="form-control"  v-model="branch_id">
                                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                          {{ item.name }}
                                        </option>
                                      </select>
                                </div>

                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                                </div>
                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                                </div>
                                    <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                        <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                          <b> عرض </b>
                                        </button>
                                    </div>
                              </div>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>من</th>
                                          <th style='text-align: center'>الى</th>
                                          <th style='text-align: center'>التاريخ</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.store_name_from}}</td>
                                          <td align='center'>{{record.store_name_to}}</td>
                                          <td align='center'>{{record.date}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteStoreMovment" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editStoreMovment" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>عرض</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                             <div class='form-group col-lg-6 col-md-6  col-sm-6' style="margin:0px;padding:0px">
                               <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                                 <label>رقم الاذن:</label>
                                 <input  :disabled="true" v-model='record.id' class='form-control' name='notes' type='text'>
                               </div>
                               <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                                 <label>الفرع:</label>
                                 <select :disabled="record.id > 0" @change='changeBranche()' class="form-control" style="padding: 0px" v-model="branch_id">
                                   <option v-for="branch in branches" v-bind:key="branch.id" v-bind:value="branch.id">
                                     {{ branch.name }}
                                   </option>
                                 </select>
                               </div>
                               <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                                 <label>من:</label>
                                 <select :disabled="record.id > 0" class="form-control" style="padding: 0px" v-model="record.store_id_from">
                                   <option v-for="branch in stores" v-bind:key="branch.id" v-bind:value="branch.id">
                                     {{ branch.name }}
                                   </option>
                                 </select>
                               </div>
                               <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                                 <label>الى:</label>
                                 <select :disabled="record.id > 0" class="form-control" style="padding: 0px" v-model="record.store_id_to">
                                   <option v-for="branch in stores" v-bind:key="branch.id" v-bind:value="branch.id">
                                     {{ branch.name }}
                                   </option>
                                 </select>
                               </div>
                               <div class='form-group col-lg-6 col-md-6 col-sm-12'>
                                 <tbDate :disabled="record.id > 0"  :mytitle='dateTitle' v-model= 'record.date' ></tbDate>
                               </div>
                               <div class='form-group col-lg-12 col-sm-12'>
                                 <label>ملاحظات:</label>
                                 <input v-model='record.notes' class='form-control' name='notes' type='text'>
                               </div>
                               <div class='form-group col-lg-12 col-sm-12'>
                                 <button @click='saveData()' type='button' class='btn btn-outline btn-primary btn-block'>حفظ بيانات الإذن</button>
                               </div>

                             </div>
                             <div v-show="record.id > 0" class='form-group col-lg-6 col-md-6  col-sm-6' style="padding: 0px 5px 0px 5px">
                               <div class='form-group col-lg-6 col-md-6 col-sm-12' style="padding: 0px 5px 0px 5px">
                                 <label>الصنف:</label>
                                 <select  ref="item_id" class="form-control" style="padding: 0px" v-model="item_id">
                                   <option v-for="item in items" v-bind:key="item.id" v-bind:value="item.id">
                                     {{ item.item }}
                                   </option>
                                 </select>
                               </div>
                               <div class='form-group col-lg-6 col-md-6  col-sm-12'   style="padding: 0px 5px 0px 5px">
                                 <label>الكمية:</label>
                                 <input v-model='amount' class='form-control' name='invoic_id' type='text'>
                               </div>
                               <div class='form-group col-lg-6 col-md-6  col-sm-12' style="padding: 23px 5px 0px 5px">
                                 <button  @click='saveItem()' type='button' class='btn btn-outline btn-primary btn-block'>حفظ الصنف للإذن</button>
                               </div>
                               <table width='100%' class='table  table-bordered ' >
                                 <thead>
                                   <tr>
                                     <th style='text-align: center'>م</th>
                                     <th style='text-align: center'>الصنف</th>
                                     <th style='text-align: center'>الكمية</th>
                                     <th style='text-align: center'>الاجراء</th>
                                   </tr>
                                 </thead>
                                 <tbody>
                                   <tr v-for='(itemRecord, index) in invoiceItems' :key='itemRecord.id'>
                                     <td style="padding:2px" align='center'>{{index +1}}</td>
                                     <td style="padding:2px" align='center'>{{itemRecord.item_name}}</td>
                                     <td style="padding:2px" align='center'>{{itemRecord.amount}}</td>
                                     <td style="padding:2px" align='center'>
                                       <vue-element-loading size='32' :active='isLoadingDeleteItem' spinner='bar-fade-scale' color='#A4A4A4'/>
                                       <button @click='deleteItem(itemRecord.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                     </td>
                                   </tr>
                                 </tbody>
                               </table>
                             </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'store_movment',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      dateTitle: 'التاريخ',
      validationErrors: '',
      records: [],
      record: {},
      item_id: '',
      amount: '',
      branches: {},
      items: {},
      stores: {},
      invoiceItems: {},
      mainValidationErrors: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      isLoadingDeleteItem: false,
      title: ''
    }
  },
  created () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.branch_id = localStorage.getItem('BrancheID')
  },
  methods: {
    changeBranche () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.stores = this.branches[i].stores
      }
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getStoreMovmentsMasters', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'store_id_from': '', 'store_id_to': '', 'date': '', 'notes': '', store_name_from: '', store_name_to: ''}
        this.changeBranche()
        this.invoiceItems = []
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
        this.changeBranche()
        this.getInvoiceItems()
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveStoreMovmentsMasters', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        store_id_from: this.record.store_id_from,
        store_id_to: this.record.store_id_to,
        date: this.record.date,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.record = res.data
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    getInvoiceItems () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getStoreMovment', {
        token: localStorage.getItem('token'),
        store_movments_masters_id: this.record.id
      })
        .then(({ data }) => {
          this.invoiceItems = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    saveItem () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveStoreMovment', {
        token: localStorage.getItem('token'),
        store_movments_masters_id: this.record.id,
        amount: this.amount,
        item_id: this.item_id,
        store_id_to: this.record.store_id_to,
        store_id_from: this.record.store_id_from
      })
        .then(res => {
          this.isLoadingSave = false
          this.invoiceItems.push(res.data)
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
          this.item_id = ''
          this.amount = ''
          this.$refs.item_id.focus()
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.mainValidationErrors = ''
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteStoreMovmentsMasters', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    },
    deleteItem (recID) {
      this.validationErrors = ''
      this.errorShow = ''
      this.successShow = ''
      this.success = ''
      this.isLoadingDeleteItem = true
      axios.post(this.$apiURL + 'deleteStoreMovment', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.invoiceItems.map(record => record.id).indexOf(recID)
          this.invoiceItems.splice(i, 1)
          this.isLoadingDeleteItem = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingDeleteItem = false
          this.$refs.item_id.focus()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/StoreMovments.vue